import { gql } from '@apollo/client';

export const CREATE_REFINERS_NOTE = gql`
  mutation CreateRefinerNote($request: CreateRefinerNoteRequest!) {
    CreateRefinerNote(request: $request) {
      id
    }
  }
`;

export const DELETE_REFINERS_NOTES = gql`
  mutation DeleteRefinerNote($id: String!) {
    DeleteRefinerNote(id: $id)
  }
`;

export const CREATE_REFINERS_NEW_REPORT = gql`
  mutation CreateRefiner($request: CreateRefinerRequest!) {
    CreateRefiner(request: $request) {
      id
    }
  }
`;

export const PIN_REFINER = gql`
  mutation PinRefiner($id: String!) {
    PinRefiner(id: $id) {
      id
    }
  }
`;

export const BULK_PIN_REFINER = gql`
  mutation BulkPinRefiner($ids: [String!]!) {
    BulkPinRefiner(ids: $ids)
  }
`;

export const UNPIN_REFINER = gql`
  mutation UnPinRefiner($id: String!) {
    UnPinRefiner(id: $id) {
      id
    }
  }
`;

export const BULK_UNPIN_REFINER = gql`
  mutation UnPinRefiner($id: String!) {
    UnPinRefiner(id: $id) {
      id
    }
  }
`;

export const UPDATE_REFINER = gql`
  mutation UpdateRefiner($id: String!, $request: UpdateRefinerRequest!) {
    UpdateRefiner(id: $id, request: $request) {
      id
    }
  }
`;
